export const iconFontAwesomeEmojiFaceKissWinkHeart = (
	<i className="fa-solid fa-face-kiss-wink-heart"></i>
);
